/* eslint-disable import/prefer-default-export */
export function getSelectedSeller() {
    if (localStorage && localStorage.getItem('seller')) {
        return JSON.parse(localStorage.getItem('seller'));
    }

    return null;
}
